import React from 'react';
import Moviedetails from './components/Moviedetails';
import { Provider } from 'react-redux';
import store from './store';
import Dashboard from './components/Dashboard';
import { Routes, Route } from 'react-router-dom';
import PopularMovAll from './components/PopularMovAll';
import NowPlayA from './components/NowplayingAll';
import TrendAll from './components/TrendAll';
import SearchRes from './components/SearchResult';
import DrawerAppBar from './components/NavBar';
import TopRateAll from './components/TopratedAll';
import PageTransition from './components/PageTransition';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <a className="skip-link" href="#main">Skip to content</a>
        <DrawerAppBar />
        <main id="main" tabIndex={-1}>
          <PageTransition>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/movie/:id" element={<Moviedetails />} />
              <Route path="/PopularA" element={<PopularMovAll />} />
              <Route path="/nowplay" element={<NowPlayA />} />
              <Route path="/trend" element={<TrendAll />} />
              <Route path="/search/:query" element={<SearchRes />} />
              <Route path="/toprated" element={<TopRateAll />} />
            </Routes>
          </PageTransition>
        </main>
      </Provider>
    </div>
  );
}

export default App;
